export enum MittanbudEnum {
  FULL_VIEW = 'full',
  SMALL_VIEW = 'small'
}

export enum MittanbudType {
  ON_SCHEDULER = 'onScheduler',
  ON_PROJECT = 'onProject'
}

export enum MittanbudEvent {
  SCHEDULER = 'mittanbud_banner_scheduler',
  PROJECT = 'mittanbud_banner_project'
}

export enum MittanbudKey {
  MITTANBUD_USER_KEY = 'show_mittanbud_banner',
  MITTANBUD_ACCOUNT_KEY = 'mittanbud_request'
}

export interface IMittanbudAuth {
  expiry: number;
  refreshToken: string | null;
  refreshTokenExpiry: number | null;
  result: string;
  token: string;
}
export interface IMittanbudContact {
  cancelClass: string;
  cancelLbl: boolean;
  classes: boolean;
  closeClass: string;
  formname: boolean;
  html: boolean;
  label: boolean;
  meta: boolean;
  ok: boolean;
  okClass: string;
  okLbl: boolean;
  okMsg: string;
  okScript: boolean;
  payload: boolean;
  result: string;
  type: boolean;
}
